import PricingIndicator from './PricingIndicator';

export default PricingIndicator;
